function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#00BF6F"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M62.908 37.873a7.145 7.145 0 0 0-1.695.21A21.844 21.844 0 0 0 43.92 21.97a20.854 20.854 0 0 0-1.101-.167c.064-2.063.158-4.448 3.195-6.592l-.48-1.21s-5.927 1.837-6.598 6.9c-.293-1.377-3.052-3.101-4.418-3.427l-.68 1.096s1.811.906 2.253 3.403a21.844 21.844 0 0 0-17.302 16.1 7.086 7.086 0 1 0 .895 13.472 21.723 21.723 0 0 0 2.3 4.28l5.882-3.963-.051-.064c-1.555-2-2.506-4.941-2.668-7.87-.175-3.233.612-6.44 2.676-8.325 4.254-3.621 8.89-1.97 11.784 1.5h.779c2.901-3.47 7.543-5.118 11.784-1.5 2.061 1.886 2.85 5.095 2.675 8.325-.159 2.929-1.11 5.87-2.667 7.87l-.051.064 5.881 3.964a21.723 21.723 0 0 0 2.307-4.281 7.083 7.083 0 1 0 2.594-13.67zm-45.944 9.16a2.09 2.09 0 1 1 1.172-3.82c.018 1.098.092 2.194.224 3.284a2.09 2.09 0 0 1-1.404.55l.008-.014zm46.07 0a2.09 2.09 0 0 1-1.395-.538c.131-1.09.206-2.187.224-3.285a2.088 2.088 0 0 1 3.26 1.733 2.085 2.085 0 0 1-2.086 2.104l-.002-.014z"
}));

var SvgSurveymonkeyIco = function SvgSurveymonkeyIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurveymonkeyIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/surveymonkey_ico.9e9dab9b.svg";
export { ForwardRef as ReactComponent };